"use strict";

exports.__esModule = true;
exports.TriggerSubscription = void 0;
var _react = require("react");
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _API = require("../../API");
var _createTriggerProcessorState = require("../createTriggerProcessorState");
var _createTriggerSubscriptionParamsFromState = require("../createTriggerSubscriptionParamsFromState");
var _processTriggerInput = require("../processTriggerInput");
var _TimeContext = require("../../Time/TimeContext");
var _EnvContext = require("../../Env/EnvContext");
var _dec, _dec2, _dec3, _class, _TriggerSubscription;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Subscribes to a map of triggers, supplies trigger results
 * to children  via a render prop.
 */
var TriggerSubscription = exports.TriggerSubscription = (_dec = _API.RealtimeConnectionContext.withContext, _dec2 = _TimeContext.TimeContext.withContext, _dec3 = _EnvContext.EnvContext.withContext, _dec(_class = _dec2(_class = _dec3(_class = (_TriggerSubscription = /*#__PURE__*/function (_Component) {
  function TriggerSubscription() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.hasMounted = false;
    _this.state = makeState(_this.props);
    _this.subscriptions = undefined;
    return _this;
  }
  _inheritsLoose(TriggerSubscription, _Component);
  TriggerSubscription.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    if (props.realtime.connection === prevState.connection && props.realtime.cache === prevState.cache && props.delay === prevState.processorState.delay && (0, _reactFastCompare["default"])(props.params, prevState.params) && (0, _reactFastCompare["default"])(Array.from(props.triggers), Array.from(prevState.processorState.triggers))) {
      return null;
    }
    return makeState(props);
  };
  var _proto = TriggerSubscription.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    this.hasMounted = true;
    this.createSubscriptions();
    this.triggerCheckInterval = setInterval(function () {
      return _this2.receiveTriggerTimeValue(_this2.props.triggers, _this2.props.delay);
    }, this.props.env.triggerSubscriptionInterval);
  };
  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.state.cache !== prevState.cache || !(0, _reactFastCompare["default"])(this.state.params, prevState.params) || !(0, _reactFastCompare["default"])(this.state.processorState.triggers, prevState.processorState.triggers)) {
      this.unsubscribeAll();
      this.createSubscriptions();
    }
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.triggerCheckInterval) {
      clearInterval(this.triggerCheckInterval);
    }
    this.unsubscribeAll();
    this.hasMounted = false;
  };
  _proto.createSubscriptions = function createSubscriptions() {
    var _this3 = this;
    var _this$state = this.state,
      cache = _this$state.cache,
      extraParams = _this$state.params,
      processorState = _this$state.processorState;
    if (cache === undefined) {
      return;
    }
    this.subscriptions = (0, _createTriggerSubscriptionParamsFromState.createTriggerSubscriptionParamsFromState)(processorState, extraParams).map(function (_ref) {
      var baseInput = _ref[0],
        item = _ref[1];
      return cache.subscribe(item, {
        next: function next(value) {
          return _this3.receiveTriggerValue(baseInput, value);
        },
        error: function error(_error) {
          return console.error(_error);
        },
        complete: function complete() {}
      });
    });
  };
  _proto.unsubscribeAll = function unsubscribeAll() {
    var subscriptions = this.subscriptions;
    if (subscriptions !== undefined) {
      for (var _iterator = _createForOfIteratorHelperLoose(subscriptions), _step; !(_step = _iterator()).done;) {
        var subscription = _step.value;
        if (!subscription.closed) {
          subscription.unsubscribe();
        }
      }
      this.subscriptions = undefined;
    }
  };
  _proto.receiveTriggerValue = function receiveTriggerValue(baseInput) {
    if (!this.hasMounted) {
      return;
    }
    var processorState = this.state.processorState;
    var nextProcessorState = (0, _processTriggerInput.processTriggerInput)(processorState, baseInput, time);
    if (nextProcessorState === processorState) {
      return;
    }
    this.setState({
      processorState: nextProcessorState
    });
  };
  _proto.receiveTriggerTimeValue = function receiveTriggerTimeValue(baseInput, value) {
    if (!this.hasMounted) {
      return;
    }
    var processorState = this.state.processorState;
    var input = Object.assign({}, baseInput, {
      value: value ? value.value : undefined
    });
    var nextProcessorState = (0, _processTriggerInput.processTriggerInput)(processorState, input, Date.now(), this.props.time.timezone.name);
    if (nextProcessorState === processorState) {
      return;
    }
    this.setState({
      processorState: nextProcessorState
    });
  };
  _proto.render = function render() {
    var children = this.props.children;
    var processorState = this.state.processorState;
    return children(processorState.results);
  };
  return TriggerSubscription;
}(_react.Component), _TriggerSubscription.defaultProps = {
  delay: 20000,
  realtime: undefined
}, _TriggerSubscription)) || _class) || _class) || _class);
function makeState(_ref2) {
  var realtime = _ref2.realtime,
    params = _ref2.params,
    triggers = _ref2.triggers,
    delay = _ref2.delay;
  var connection = realtime.connection,
    cache = realtime.cache;
  var processorState = (0, _createTriggerProcessorState.createTriggerProcessorState)(triggers, delay);
  return {
    connection: connection,
    cache: cache,
    params: params,
    processorState: processorState
  };
}